// Firestore rules recognise teachers by the `teacher` claim on the ID token,
// but the claim is added after the profile becomes a teacher, so a token issued
// earlier (for example at registration) doesn't carry it until refreshed.

import { API_BASE_URL } from "./apiBase";

const hasTeacherClaim = async (currentUser, forceRefresh) =>
  (await currentUser.getIdTokenResult(forceRefresh))?.claims?.teacher === true;

/**
 * Makes sure the signed-in teacher's token carries the teacher claim.
 * Returns "present", "refreshed", "synced" or "missing" ("unavailable" when
 * the user object can't report claims). Never throws.
 */
export async function ensureTeacherClaim(currentUser, { fetchImpl = fetch } = {}) {
  if (!currentUser || typeof currentUser.getIdTokenResult !== "function") return "unavailable";
  try {
    if (await hasTeacherClaim(currentUser, false)) return "present";
    if (await hasTeacherClaim(currentUser, true)) return "refreshed";
    const response = await fetchImpl(`${API_BASE_URL}/api/auth/sync-role-claims`, {
      method: "POST",
      headers: { Authorization: `Bearer ${await currentUser.getIdToken()}` },
    });
    if (response.ok && await hasTeacherClaim(currentUser, true)) return "synced";
    return "missing";
  } catch (error) {
    console.error("Could not refresh teacher permissions:", error);
    return "missing";
  }
}
